import React from 'react';
import PropTypes from 'prop-types';

import { useSSRQuery } from '../';

export const TranslationsContext = React.createContext({});
export const useTranslations = () => React.useContext(TranslationsContext);

const translationsProviderPropTypes = {
  query: PropTypes.object,
  children: PropTypes.node,
};

const TranslationsProvider = ({ query, children }) => {
  const { loading, error, data } = useSSRQuery(query);

  if (loading) {
    return null;
  }

  if (error) {
    throw error;
  }

  if (data && !data.application && !data.allegiantApplication) {
    throw new Error(
      `You need to supply a translation query to "withTranslation" or to "TranslationProvider". The provided query is not a translation query: ${query.loc.source.body}`
    );
  }

  const applicationData = data?.allegiantApplication
    ? data.allegiantApplication
    : data?.application;

  return (
    <TranslationsContext.Provider value={applicationData?.translations}>
      {children}
    </TranslationsContext.Provider>
  );
};

TranslationsProvider.propTypes = translationsProviderPropTypes;

export function withTranslations(query, WrappedComponent) {
  return function TranslationsHOC(props) {
    return (
      <TranslationsProvider query={query}>
        <WrappedComponent {...props} />
      </TranslationsProvider>
    );
  };
}

export default TranslationsProvider;
